"use strict";

require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDecorator = void 0;
var _utils = require("../utils");
var createDecorator = function createDecorator(wrapper) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (typeof wrapper !== 'function') throw Error('[create-decorator]: createDecorator Please pass in a higher-order function');
  return function handleDescriptor(target, key, descriptor) {
    if (!descriptor && typeof target === 'function') {
      return wrapper(target);
    }
    if (descriptor && !(0, _utils.isObject)(descriptor)) {
      throw Error('[create-decorator]: Descriptor is not a description object. Please check that @decorator is the correct decorator structure: function (target, name, descriptor) { ... }');
    }
    var configurable = descriptor.configurable,
      enumerable = descriptor.enumerable;
    var originalGet = descriptor.get;
    var originalSet = descriptor.set;
    var originalValue = descriptor.value;
    var originInitializer = descriptor.initializer;
    var isGetter = !!originalGet;
    var defaultSetter = function defaultSetter(newValue) {
      return originalValue = newValue;
    };
    var wrappedFn;
    var desc = {
      configurable: configurable,
      enumerable: enumerable
    };
    if (typeof originInitializer === 'function') {
      desc.initializer = function initializer() {
        if (!wrappedFn) {
          var realMethod = originInitializer.call(this).bind(this);
          wrappedFn = wrapper.call.apply(wrapper, [this, realMethod].concat(args));
        }
        return function realMethodCall() {
          var _wrappedFn;
          for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            nextArgs[_key2] = arguments[_key2];
          }
          return (_wrappedFn = wrappedFn).call.apply(_wrappedFn, [this].concat(nextArgs));
        };
      };
    } else {
      desc.get = function get() {
        if (wrappedFn) return wrappedFn;
        var realMethod;
        if (isGetter) {
          realMethod = originalGet.call(this).bind(this);
        } else if (typeof originalValue === 'function') {
          realMethod = originalValue.bind(this);
        } else {
          throw Error('[create-decorator]: descriptor\'s `value` or `get` property is not a function');
        }
        wrappedFn = wrapper.call.apply(wrapper, [this, realMethod].concat(args));
        return wrappedFn;
      };
      desc.set = isGetter ? originalSet : defaultSetter;
    }
    return desc;
  };
};
exports.createDecorator = createDecorator;